import { createReducer, on } from '@ngrx/store';
import * as SquareProductSalesActions from './square-product-sales.actions';
import { SquareProductSales } from './square-product-sales.models';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface SquareProductSalesState {
    squareProductSales: SquareProductSales[];
    squareProductSale: SquareProductSales | null;
    totalCount: number;
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialSquareProductSalesState: SquareProductSalesState = {
    squareProductSales: [],
    squareProductSale: null,
    totalCount: 0,
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

export const squareProductSalesReducer = createReducer(
    initialSquareProductSalesState,

    // Load all
    on(SquareProductSalesActions.loadSquareProductSales, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        SquareProductSalesActions.loadSquareProductSalesSuccess,
        (state, { squareProductSales, totalCount }) => ({
            ...state,
            isLoading: false,
            squareProductSales,
            totalCount,
        })
    ),
    on(SquareProductSalesActions.loadSquareProductSalesFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // Load single
    on(SquareProductSalesActions.loadSquareProductSale, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        SquareProductSalesActions.loadSquareProductSaleSuccess,
        (state, { squareProductSale }) => ({
            ...state,
            isLoading: false,
            squareProductSale,
        })
    ),
    on(SquareProductSalesActions.loadSquareProductSaleFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // Create
    on(SquareProductSalesActions.createSquareProductSale, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        SquareProductSalesActions.createSquareProductSaleSuccess,
        (state, { squareProductSale }) => ({
            ...state,
            isLoading: false,
            squareProductSales: [...(state.squareProductSales || []), squareProductSale],
        })
    ),
    on(SquareProductSalesActions.createSquareProductSaleFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // Update
    on(SquareProductSalesActions.updateSquareProductSale, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        SquareProductSalesActions.updateSquareProductSaleSuccess,
        (state, { squareProductSale }) => ({
            ...state,
            isLoading: false,
            squareProductSales: state.squareProductSales.map((s) =>
                s.id === squareProductSale.id ? squareProductSale : s
            ),
        })
    ),
    on(SquareProductSalesActions.updateSquareProductSaleFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // Delete
    on(SquareProductSalesActions.deleteSquareProductSale, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SquareProductSalesActions.deleteSquareProductSaleSuccess, (state, { id }) => ({
        ...state,
        isLoading: false,
        squareProductSales: state.squareProductSales.filter((s) => s.id !== id),
    })),
    on(SquareProductSalesActions.deleteSquareProductSaleFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    }))
);
